export default __webpack_public_path__ + "f4700ab89c84e73e8c86280069b0cc47.jpg";